export const creator_GYO4CTB4 = {
  theme: {
    is_telegram_white_theme: true,
  }
};